import { IBasics } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import React from 'react';
import { MouseParallax } from 'react-just-parallax';
import AnimatedTitle from '../../components/AnimatedTitle';
import Ellipse from '../../components/Ellipse';
import Img from '../../components/Img';
import clientDeviceSize, { ScreenSize } from '../../store/deviceScreenSize';
import { theme, Theme } from '../../store/theme';
import styles from './EducationBasics.module.scss';
import { EllipseVariants } from '../../../constants';

type EducationBasicsProps = {
  data: IBasics[]
};
const EducationBasics = ({ data }: EducationBasicsProps) => {
  const appTheme = useAtomValue<Theme>(theme);
  const deviceSize = useAtomValue<ScreenSize>(clientDeviceSize);

  return (
    <section className={classnames(styles.basics, 'container')}>
      <h2 className={classnames(styles.title, 'title3')}><AnimatedTitle title='Tech **Basics** To Know' /></h2>
      {deviceSize > ScreenSize.TABLET_PORTRAIT && (
        <div className={styles.parallax}>
          <MouseParallax
            shouldPause={false}
            isAbsolutelyPositioned
            strength={0.05}
          >
            <Ellipse
              variant={EllipseVariants.DRAW}
              size={800}
              className={styles.parallax__draw}
            />
          </MouseParallax>
          <MouseParallax
            shouldPause={false}
            isAbsolutelyPositioned
            strength={0.12}
          >
            <Ellipse
              variant={EllipseVariants.NOISE}
              size={40}
              className={styles.parallax__noise}
            />
          </MouseParallax>
          <MouseParallax
            shouldPause={false}
            isAbsolutelyPositioned
            strength={0.08}
          >
            <Ellipse
              variant={EllipseVariants.GRADIENT}
              size={100}
              className={styles.parallax__gradient}
            />
          </MouseParallax>
        </div>
      )}
      <div className={styles.content}>
        {data.map(technology => (
          <div
            className={styles.technology}
            key={technology.id}
          >
            <div className={styles.icon}>
              <Img
                src={technology.image[appTheme].url}
                alt={technology.image[appTheme].alternativeText || 'technology icon'}
              />
            </div>
            <div className={styles.technology__list}>
              {technology.list.map(listItem => (
                <p
                  key={listItem.text}
                  className={styles.listItem}
                >
                  {listItem.text}
                </p>
              ))}
            </div>
            <a
              href={technology.checklistUrl}
              download
              className={styles.checklistLink}
            >
              Checklist
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EducationBasics;
